import styled from 'styled-components'
import { config } from 'config/index'

const { APP_SKIN_VERSION } = config

export const ContentSwitcherBySkin = ({ className, noWrapper, noWarning, componentsBySkin, onChildrenNull }) => {
  const activeSkin = Object.keys(componentsBySkin).includes(APP_SKIN_VERSION) ? APP_SKIN_VERSION : 'notDefined'

  const componentToRender = componentsBySkin[activeSkin]

  if (activeSkin === 'notDefined' && noWarning) return null
  if (activeSkin === 'notDefined') return <div></div>

  if (!componentToRender) {
    onChildrenNull(true)
    return null
  }

  return noWrapper ? (
    <> {componentToRender} </>
  ) : (
    <SwitcherContainer id='switcherContainer' className={className}>
      {componentToRender}
    </SwitcherContainer>
  )
}

const SwitcherContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
`
